import { create } from 'zustand';

export type CursorCoords = {
  x: number;
  y: number;
  wkid?: number;
};

type State = {
  coords: CursorCoords | null;
  scale: number | null;
  zoom: number | null;
  setCoords: (coords: CursorCoords | null) => void;
  setScale: (scale: number) => void;
  setZoom: (zoom: number) => void;
};

export const useViewStateStore = create<State>((set) => ({
  coords: null,
  scale: null,
  zoom: null,
  setCoords: (coords) => set({ coords }),
  setScale: (scale) => set({ scale }),
  setZoom: (zoom) => set({ zoom }),
}));
